<template>
	<div class="tab-page">
		<form @submit.prevent="save" ref="form">
			<div class="field">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<label for="password">{{$t('password')}}</label>
							<div class="element">
								<div class="flex">
									<input type="password" placeholder=" " id="password" v-model="$parent.password">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr>
			<div class="container">
				<div class="content">
					<button>{{$t('save')}}</button>
					<button @click.prevent="remoteControl" class="button-outline">{{$t('remote-control')}}</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	data() {
		return {

		}
	},
	methods: {
		save() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			
			let self = this;

			self.$storage.getItem(`customer-${self.$store.getters.getProfile.id}`)
			.then((response) => {
				let customer;
				try {
					customer = JSON.parse(response);
				} catch(e) {
				}
				if (customer == null) customer = {};
				customer[`machine-${self.$parent.machine.name}-password`] = self.$parent.password;
				let parsed = JSON.stringify(customer);
				return self.$storage.setItem(`customer-${self.$store.getters.getProfile.id}`, parsed);
			})
			.then(() => {
				self.$snack.success({button: null, text: self.$t('password-saved-successfully')});
			})
			.catch((err) => {
				console.log(err);
			});
		},
		remoteControl() {
			this.$router.push({name: 'remote-control', params: {id: this.$parent.machine.id}});
		},
	},
}
</script>